import { CssBaseline, Typography, WithStyles, withStyles } from "@material-ui/core";
import { styles } from "./InfoCenterView.styles";
import { useHistory } from "react-router-dom";
import React from "react";
import { useTranslation } from "react-i18next";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";

export interface IInfoCenterViewProps extends WithStyles<typeof styles> {
}

const InfoCenterViewPure: React.FunctionComponent<IInfoCenterViewProps> = ({classes}) => {

    const {t} = useTranslation();

    const history = useHistory();
    const links = [
        {name: t("mainNavBar.tickData"), link: ("/data")},
        {name: t("mainNavBar.indexData"), link: ("/data")},
        {name: t("mainNavBar.marketData"), link: ("/data")},
        {name: t("mainNavBar.hptData"), link: ("/data")},
        {name: t("mainNavBar.analyticsData"), link: ("/data")},
        {name: t("mainNavBar.referenceData"), link: ("/data")},
    ];

    const handleLinks = (linkIndex) => {
        history.push(links[linkIndex].link);
    };

    return <CenteredContainer>
        <CssBaseline />
        <div className={classes.title}>
            <Typography variant="h2">{t("infoCenter.header")}</Typography>
            <Typography variant="h3">{t("infoCenter.welcomeTitle")}</Typography>
            <Typography variant="body1">{t("infoCenter.welcomeText")}</Typography>

            <Typography variant="h3">{t("infoCenter.findTitle")}</Typography>
            <Typography variant="body1">{t("infoCenter.findText")}</Typography>
            {links.map((oneLink, index) => (
                <Typography variant="body1" className={classes.link}
                            onClick={() => handleLinks(index)}>{oneLink.name}</Typography>
            ))}
            <Typography variant="body1">{t("infoCenter.useText")}</Typography>

            <Typography variant="h3">{t("infoCenter.orderTitle")}</Typography>
            <Typography variant="body1">{t("infoCenter.orderText")}</Typography>

            <Typography variant="h3">{t("infoCenter.downloadTitle")}</Typography>
            <Typography variant="body1">{t("infoCenter.downloadText")}</Typography>

            <Typography variant="h3">{t("infoCenter.paymentTitle")}</Typography>
            <Typography variant="body1">{t("infoCenter.paymentText")}</Typography>

            <Typography variant="h3">{t("infoCenter.administrativeTitle")}</Typography>
            <Typography variant="body1">{t("infoCenter.administrativeText")}</Typography>

            <Typography variant="h3">{t("infoCenter.helpTitle")}</Typography>
            <Typography variant="body1">{t("infoCenter.helpText")}</Typography>
        </div>

    </CenteredContainer>;
};

export const InfoCenterView = withStyles(styles)(InfoCenterViewPure);
